import { ExpansionModalProvider } from "./ExpansionModalContext";
import ExpansionModalContainer from "./ExpansionModalContainer";

// Component is faking a modal for seamless transition to fullscreen mode (and no re-renders)

// Note: on the child asset that is expanding, you must set the asset's open/closed width/height within it's classname. useExpansionModalContext to retrieve isOpen state.

// TO DO: make route for it in design-system?

const ExpansionModal: React.FC<{
  children: React.ReactNode;
  classes?: {
    open?: string;
    closed?: string;
  };
}> = ({ children, classes }) => {
  return (
    <ExpansionModalProvider>
      <ExpansionModalContainer classes={classes}>
        {children}
      </ExpansionModalContainer>
    </ExpansionModalProvider>
  );
};

export default ExpansionModal;
